class ApiService {
	constructor() {
		this.controllers = new Map();
	}

	createAbortController(key) {
		this.abort(key);

		const controller = new AbortController();
		this.controllers.set(key, controller);
		return controller;
	}

	abort(key) {
		const controller = this.controllers.get(key);
		if (controller) {
			controller.abort();
			this.controllers.delete(key);
		}
	}

	abortAll() {
		this.controllers.forEach(controller => controller.abort());
		this.controllers.clear();
	}

	async request(url, options = {}, key = null) {
		const controller = key ? this.createAbortController(key) : new AbortController();

		const token = sessionStorage.getItem('session_token');
		const headers = {
			...options.headers
		};

		if (token && !headers.Authorization) {
			headers.Authorization = `Bearer ${ token }`;
		}

		try {
			const response = await fetch(url, {
				...options,
				headers,
				signal: controller.signal
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${ response.status }`);
			}

			const data = await response.json();

			if (key) {
				this.controllers.delete(key);
			}

			return data;
		} catch (error) {
			if (error.name === 'AbortError') {
				console.log('Request aborted:', url);
				return null;
			}
			throw error;
		}
	}

	async get(url, options = {}, key = null) {
		return this.request(url, {
			...options,
			method: 'GET'
		}, key);
	}

	async post(url, data = {}, options = {}, key = null) {
		const isFormData = data instanceof FormData;

		const requestOptions = {
			...options,
			method: 'POST',
			body: isFormData ? data : JSON.stringify(data)
		};

		if (!isFormData) {
			requestOptions.headers = {
				'Content-Type': 'application/json',
				...options.headers
			};
		}

		return this.request(url, requestOptions, key);
	}

	async delete(url, options = {}, key = null) {
		return this.request(url, {
			...options,
			method: 'DELETE'
		}, key);
	}

	useAbortOnUnmount(keys = []) {
		return () => {
			keys.forEach(key => this.abort(key));
		};
	}
}

export default new ApiService();